export const isMobileSmall: boolean = window.screen.width <= 360;
export const isMobileRegular: boolean = window.screen.width <= 480;
